export enum SettingsWorkforceStaffingsDataEventObjectsEnum {
  // Table view.
  WFM_START_CREATE_SHIFT_FROM_CELL = 'wfm_start_create_shift_from_cell',
  WFM_START_CREATE_SHIFT = 'wfm_start_create_shift',
  WFM_SHIFT = 'wfm_shift',

  // Editor panel.
  WFM_CREATE_SHIFT = 'wfm_create_shift',
  WFM_SHIFT_EDIT_SAVE = 'wfm_shift_edit_save',
  WFM_SHIFT_DELETE = 'wfm_shift_delete',

  // Staffing requirements.
  WFM_SET_STAFFING_GOALS = 'wfm_set_staffing_goals',
  WFM_STAFFING_GOAL_CREATE = 'wfm_staffing_goal_create',
  WFM_STAFFING_GOAL_EDIT_SAVE = 'wfm_staffing_goal_edit_save',

  // Filters.
  WFM_INBOXES_FILTER = 'wfm_inboxes_filter',
  WFM_TEAMMATES_FILTER = 'wfm_teammates_filter',
  WFM_SHIFTS_FILTER = 'wfm_shifts_filter',
  WFM_DISPLAY_SHIFTS_WITH_CONFLICT_TOGGLE = 'wfm_display_shifts_with_conflict_toggle',
}
